/*jshint globalstrict: false*/

import Vue from 'vue';
import GiftHomeShell from '../components/home/gift/gift-shell-home';
import axios from 'axios';

Vue.component('gift-home-shell', GiftHomeShell);

document.addEventListener('DOMContentLoaded', () => {
    Vue.use({
        install (Vue) {
            Vue.prototype.$thirdPartyApi = axios.create({});

            const csrfToken = document.querySelector("meta[name=csrf-token]").content;
            axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

            Vue.prototype.$api = axios.create({
                baseURL: '/'
            });
        }
    });

    new Vue({
        el: '[data-behavior="gift-home-vue"]',
    });
});
